<template>
  <div class="jam-page">

    <div class="jam-hero" style="background: #BB4A8C; position: relative; overflow: hidden;">
      <div class="d-flex align-items-center justify-content-center pt-3">
        <h1 class="text-uppercase display-header home-text mx-2 text-center" style="color:#fff;">UP ALL NIGHT JAM</h1>
      </div>

      <div class="d-flex align-items-center justify-content-center pt-2 pb-3" v-if="jamDateText">
        <span style="color:#fff; font-size: 1.6rem; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; text-align: center;">{{ jamDateText }}</span>
      </div>

      <div class="d-flex align-items-center justify-content-center pt-3 pb-5 px-4">
        <div style="max-width: 800px; color:#fff; font-size: 1.1rem; line-height: 1.6; text-align: center;">
          <p>The Up All Night Jam is a free jam that is open to improvisers of all skill levels. The sign-ups are done in person and are open from the conclusion of our 9pm show until the show's start time. You can register as a team or as an individual. Individuals will be assembled into a team by the host during the show. The length and number of sets depend on the number of participants.</p>
          <div style="color:#fff; font-size: 1.6rem; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; text-align: center; margin: 1.5rem 0;">This event is FREE!</div>
          <p>The Jam concludes with two 5 minute head to head sets with no rules, just raw improv. Two names will be selected from the bucket (participation is voluntary). The audience will vote on the winner who will then go head to head vs the previous month's Champion. The ultimate winner will then live forever on the Timeline of Champions with a chance to defend their title next month.</p>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center pb-5" v-if="jamShowLink">
        <a :href="jamShowLink">
          <div class="btn text-uppercase" style="background-color: white; color: #BB4A8C; min-width: 180px;" type="button">Get Tickets</div>
        </a>
      </div>
    </div>

    <div class="w-100 mb-3" style="height: 2px; background:#fff;"></div>

    <!-- Your Host Section -->
    <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
      <div class="host-section">
        <!-- Image Column -->
        <div class="host-image-col">
          <img :src="hostImg" class="host-image" />
        </div>
        <!-- Text Column -->
        <div class="host-text-col">
          <h2 class="text-uppercase oswald-bold" style="color:#fff; font-size: 2.8rem; margin-bottom: 1.5rem;">Host</h2>
          <div style="font-family: 'Oswald', sans-serif; font-size: 1.6rem; font-weight: 700; text-transform: uppercase; letter-spacing: 4px; color:#b65792; margin-bottom: 1.5rem;">Chelsey Gonzalez</div>
          <p style="color:#fff; font-size: 1.1rem; line-height: 1.6;">
            Chelsey proved at the inaugural <strong>Up All Night Jam</strong> that she could win the belt whenever her name is called. As the host she's tough, fair and unwilling to tolerate weakness. This may be a show for all but never forget it's her show to run.
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center pt-3 pb-5">
      <div class="champion-section-inner" style="position: relative; display: inline-block; width: 100%; max-width: 800px;">
        <div class="champion-line-dots">
          <div class="champion-dot" style="left: 0%; background: #138b4d; box-shadow: 0 0 8px #138b4d;"></div>
          <div class="champion-dot" style="left: 20%; background: #DEC75C; box-shadow: 0 0 8px #DEC75C;"></div>
          <div class="champion-dot" style="left: 40%; background: #E35B4B; box-shadow: 0 0 8px #E35B4B;"></div>
          <div class="champion-dot" style="left: 60%; background: #b65792; box-shadow: 0 0 8px #b65792;"></div>
          <div class="champion-dot" style="left: 80%; background: #39a5bf; box-shadow: 0 0 8px #39a5bf;"></div>
          <div class="champion-dot" style="left: 100%; background: #138b4d; box-shadow: 0 0 8px #138b4d;"></div>
          <div class="champion-dot-center"></div>
        </div>
        <span class="text-uppercase home-text" style="color:#fff; font-size: 2.8rem; display: block; text-align: center;">TIMELINE OF CHAMPIONS</span>
        <!-- Horizontal connecting lines at bottom of vertical lines -->
        <div class="champion-bottom-lines">
          <div class="champion-bottom-seg" style="background: linear-gradient(to right, #138b4d, #DEC75C);"></div>
          <div class="champion-bottom-seg" style="background: linear-gradient(to right, #DEC75C, #E35B4B);"></div>
          <div class="champion-bottom-seg" style="background: linear-gradient(to right, #E35B4B, #b65792);"></div>
          <div class="champion-bottom-seg" style="background: linear-gradient(to right, #b65792, #39a5bf);"></div>
          <div class="champion-bottom-seg" style="background: linear-gradient(to right, #39a5bf, #138b4d);"></div>
        </div>
      </div>
    </div>

    <div class="jam-container py-5" style="padding-top: calc(4.5rem + 24px) !important;">
      <div class="timeline">
        <div class="timeline-line"></div>

        <div
          v-for="(entry, index) in entries"
          :key="entry.name"
          class="timeline-entry"
          :class="{ 'timeline-entry--visible': visibleIndices.has(index) }"
          :data-index="index"
        >
          <!-- Left side -->
          <div class="entry-side entry-side--left">
            <template v-if="index % 2 === 0">
              <!-- image on left -->
              <div class="timeline-card">
                <div class="img-box">
                  <img :src="entry.src" :alt="entry.name" class="timeline-img" />
                </div>
                <div class="timeline-name oswald-bold" :style="{ color: entry.color }">{{ entry.monthYear }}</div>
              </div>
            </template>
            <template v-else>
              <!-- name placeholder on left -->
              <div class="entry-label" :style="{ color: entry.color }">
                <span>{{ entry.winner }}</span>
                <div v-if="entry.stars" class="winner-stars" :aria-label="entry.stars + '-time champion'">
                  <span v-for="n in entry.stars" :key="n">★</span>
                </div>
              </div>
            </template>
          </div>

          <!-- Dot -->
          <div class="timeline-dot" :style="{ background: entry.color, boxShadow: `0 0 8px ${entry.color}` }"></div>

          <!-- Right side -->
          <div class="entry-side entry-side--right">
            <template v-if="index % 2 === 0">
              <!-- name placeholder on right -->
              <div class="entry-label" :style="{ color: entry.color }">
                <span>{{ entry.winner }}</span>
                <div v-if="entry.stars" class="winner-stars" :aria-label="entry.stars + '-time champion'">
                  <span v-for="n in entry.stars" :key="n">★</span>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- image on right -->
              <div class="timeline-card">
                <div class="img-box">
                  <img :src="entry.src" :alt="entry.name" class="timeline-img" />
                </div>
                <div class="timeline-name oswald-bold" :style="{ color: entry.color }">{{ entry.monthYear }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue';
import axios from 'axios';
import dec25 from '@/assets/uanj/DEC_25.png';
import jan26 from '@/assets/uanj/JAN_26.png';
import feb26 from '@/assets/uanj/FEB_26.png';
import mar26 from '@/assets/uanj/MAR_26.png';
import apr26 from '@/assets/uanj/APR_26.png';
import may26 from '@/assets/uanj/MAY_26.png';
import jun26 from '@/assets/uanj/JUN_26.png';
import jul26 from '@/assets/uanj/JUL_26.png';
import aug26 from '@/assets/uanj/AUG_26.png';
import sep26 from '@/assets/uanj/SEP_26.png';
import oct26 from '@/assets/uanj/OCT_26.png';
import nov25 from '@/assets/uanj/NOV_25.png';
import oct25 from '@/assets/uanj/OCT_25.png';
import sep25 from '@/assets/uanj/SEP_25.png';
import hostImg from '@/assets/uanj/Your_host_3_duo.png';
import jamData from '@/assets/jam_entries.json';

const imageMap = {
  'SEP_25.png': sep25,
  'OCT_25.png': oct25,
  'NOV_25.png': nov25,
  'DEC_25.png': dec25,
  'JAN_26.png': jan26,
  'FEB_26.png': feb26,
  'MAR_26.png': mar26,
  'APR_26.png': apr26,
  'MAY_26.png': may26,
  'JUN_26.png': jun26,
  'JUL_26.png': jul26,
  'AUG_26.png': aug26,
  'SEP_26.png': sep26,
  'OCT_26.png': oct26,
};

export default {
  name: 'Jam',
  components: { Footer },
  data() {
    // Running win count per champion. entries are newest-first, so tally from
    // oldest -> newest to get each belt's win ordinal (1st win, 2nd win, ...).
    const raw = jamData.entries;
    const tally = {};
    const winNumber = new Array(raw.length);
    for (let i = raw.length - 1; i >= 0; i--) {
      const w = raw[i].winner;
      tally[w] = (tally[w] || 0) + 1;
      winNumber[i] = tally[w];
    }
    // Stars shown under the name: 1st win = 0, 2nd = 2, 3rd = 3, ... (n === 1 ? 0 : n)
    return {
      hostImg,
      entries: raw.map((entry, i) => ({
        src: imageMap[entry.image],
        name: entry.name,
        monthYear: entry.monthYear,
        winner: entry.winner,
        color: entry.color,
        stars: winNumber[i] === 1 ? 0 : winNumber[i]
      })),
      jamShowLink: null,
      jamDateText: null,
      visibleIndices: new Set()
    };
  },
  methods: {
    async fetchJamShowLink() {
      const url = this.$API_GRAPHQL;
      const headers = {
        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
        'Content-Type': 'application/json'
      };
      try {
        const response = await axios.post(url, {
          query: `
            query {
              show(filter: { name: { _icontains: "up all night jam" } }) {
                fw_link
                date_text
              }
            }
          `
        }, { headers });

        const jamShow = response.data.data.show && response.data.data.show[0];
        if (jamShow) {
          if (jamShow.fw_link) {
            this.jamShowLink = jamShow.fw_link;
          }
          if (jamShow.date_text) {
            this.jamDateText = jamShow.date_text;
          }
        }
      } catch (error) {
        console.error('Error fetching JAM show:', error);
      }
    }
  },
  created() {
    this.fetchJamShowLink();
  },
  mounted() {
    this.$nextTick(() => {
      const dotsLine = this.$el.querySelector('.champion-line-dots');
      if (dotsLine) {
        const dotsObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              dotsLine.classList.add('dots-visible');
              const timelineLine = this.$el.querySelector('.timeline-line');
              if (timelineLine) {
                const glowSteps = [
                  { delay: 0,   glow: '0 0 4px 1px rgba(255,255,255,0.3)' },
                  { delay: 150, glow: '0 0 6px 2px rgba(255,255,255,0.45)' },
                  { delay: 300, glow: '0 0 9px 3px rgba(255,255,255,0.6)' },
                  { delay: 450, glow: '0 0 12px 4px rgba(255,255,255,0.75)' },
                  { delay: 600, glow: '0 0 15px 5px rgba(255,255,255,0.9)' },
                ];
                glowSteps.forEach(({ delay, glow }) => {
                  setTimeout(() => {
                    timelineLine.style.setProperty('--dot-glow', glow);
                    timelineLine.classList.add('dot-visible');
                  }, delay);
                });
              }
              dotsObserver.disconnect();
            }
          });
        }, { threshold: 0.5 });
        dotsObserver.observe(dotsLine);
      }

      const entries = this.$el.querySelectorAll('.timeline-entry');
      const observer = new IntersectionObserver((observerEntries) => {
        observerEntries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            this.visibleIndices.add(index);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      entries.forEach(entry => observer.observe(entry));
    });
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes dotAppear {
  0%   { opacity: 0; box-shadow: 0 0 0px 0px rgba(255,255,255,0); }
  50%  { opacity: 1; box-shadow: 0 0 14px 6px rgba(255,255,255,0.85); }
  75%  { box-shadow: 0 0 6px 2px rgba(255,255,255,0.4); }
  100% { opacity: 1; }
}

@keyframes glowBounce {
  0%   { box-shadow: 0 0 4px 1px rgba(255,255,255,0.3); }
  5%   { box-shadow: 0 0 6px 2px rgba(255,255,255,0.45); }
  11%  { box-shadow: 0 0 8px 3px rgba(255,255,255,0.6); }
  16%  { box-shadow: 0 0 11px 4px rgba(255,255,255,0.75); }
  21%  { box-shadow: 0 0 14px 5px rgba(255,255,255,0.9); }
  100% { box-shadow: 0 0 14px 5px rgba(255,255,255,0.9); }
}

@keyframes revealLeft {
  from { transform: scaleX(0); opacity: 0; }
  to { transform: scaleX(1); opacity: 1; }
}

@keyframes growDown {
  from {
    transform: translateX(-50%) scaleY(0);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) scaleY(1);
    opacity: 1;
  }
}

.host-section {
  max-width: 1200px;
  width: 100%;
  display: flex;
  gap: 3rem;
  align-items: center;
  padding: 0 2rem;
}

.host-image-col {
  flex: 1;
  text-align: center;
}

.host-text-col {
  flex: 1;
}

.host-image {
  width: 450px;
  height: auto;
  margin: 0 auto 2rem;
  display: block;
  animation: fadeIn 1.5s ease-in;
}

@media (max-width: 768px) {
  .host-section {
    flex-direction: column;
    gap: 2rem;
  }

  .host-image {
    width: 300px;
  }

  .host-text-col h2 {
    text-align: center;
  }

  .host-text-col > div {
    text-align: center;
  }

  .host-text-col p {
    text-align: center;
  }

  .display-header.text-uppercase {
    font-size: 3rem !important;
  }

  .btn.text-uppercase {
    font-size: 1rem !important;
    min-width: 0 !important;
    padding: 0.5rem 1.5rem !important;
  }
}

.jam-page {
  min-height: 100vh;
  background: #231F20;
}

.jam-hero {
  position: relative;
  padding: 40px 20px;
}

.jam-container {
  display: flex;
  justify-content: center;
  padding: 0 1rem;
}

/* ── Timeline wrapper ── */
.timeline {
  position: relative;
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 40px 0;
}

/* ── Continuous gradient line — blue → magenta → gold (reversed) ── */
.timeline-line {
  position: absolute;
  left: 50%;
  top: -16px;
  bottom: 0;
  width: 3px;
  transform: translateX(-50%);
  background: linear-gradient(to bottom, #39a5bf 0%, #138b4d 7.69%, #DEC75C 15.38%, #E35B4B 23.08%, #b65792 30.77%, #39a5bf 38.46%, #138b4d 46.15%, #DEC75C 53.85%, #E35B4B 61.54%, #b65792 69.23%, #39a5bf 76.92%, #138b4d 84.62%, #DEC75C 92.31%, #E35B4B 100%);
  z-index: 5;
}

.timeline-line {
  --dot-glow: 0 0 0px 0px rgba(255,255,255,0);
}

.timeline-line::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  border: 2px solid #231F20;
  z-index: 10;
  box-shadow: var(--dot-glow);
  transition: box-shadow 0.3s ease-out;
}


.champion-line-dots {
  position: absolute;
  bottom: -35px;
  left: 0;
  right: 0;
  height: 3px;
  background: none;
}

.champion-dot {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #231F20;
  opacity: 0;
  z-index: 2;
}

.champion-line-dots.dots-visible > .champion-dot {
  animation: dotAppear 1.4s ease-out both;
}

.champion-line-dots.dots-visible > .champion-dot:nth-child(1) { animation-delay: 0s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(2) { animation-delay: 0.15s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(3) { animation-delay: 0.3s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(4) { animation-delay: 0.45s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(5) { animation-delay: 0.6s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(6) { animation-delay: 0.75s; }

.champion-dot::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 100%;
  width: 3px;
  height: 93px;
  transform: translateX(-50%) scaleY(0);
  transform-origin: top center;
  background: inherit;
  filter: drop-shadow(0 0 4px currentColor);
  z-index: -1;
  opacity: 0;
}

.champion-line-dots.dots-visible > .champion-dot::after {
  animation: growDown 0.6s ease-out both;
}

.champion-line-dots.dots-visible > .champion-dot:nth-child(1)::after { animation-delay: 0.1s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(2)::after { animation-delay: 0.25s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(3)::after { animation-delay: 0.4s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(4)::after { animation-delay: 0.55s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(5)::after { animation-delay: 0.7s; }
.champion-line-dots.dots-visible > .champion-dot:nth-child(6)::after { animation-delay: 0.85s; }

.champion-line-dots > .champion-dot:nth-child(1)::after,
.champion-line-dots > .champion-dot:nth-child(6)::after {
  height: 95px;
}

/* The vertical lines are 80px tall, so horizontal lines should start at -35px (dots) -80px (line height) = -115px */

.champion-bottom-lines {
  position: absolute;
  bottom: -136px;
  left: 0;
  right: 0;
  display: flex;
  height: 3px;
  z-index: 5;
  pointer-events: none;
  transform: scaleX(0);
  transform-origin: left center;
  opacity: 0;
}

.champion-line-dots.dots-visible ~ .champion-bottom-lines {
  animation: revealLeft 0.6s ease-out 0.85s both;
}

.champion-bottom-seg {
  flex: 1;
  height: 3px;
}


.champion-dot-center {
  display: none;
}


/* ── Each entry: two sides + dot ── */
.timeline-entry {
  position: relative;
  display: flex;
  align-items: center;
  z-index: 10;
}

.entry-side {
  flex: 1;
  display: flex;
}

.entry-side--left {
  justify-content: flex-end;
  padding-right: 2.5rem;
}

.entry-side--right {
  justify-content: flex-start;
  padding-left: 2.5rem;
}

/* ── Dot ── */
.timeline-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #231F20;
  flex-shrink: 0;
  z-index: 10;
}

/* ── Image card ── */
.timeline-card {
  text-align: center;
}

.img-box {
  width: 220px;
  height: 400px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.timeline-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
}

.timeline-name {
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-top: 0.5rem;
}

.timeline-entry[data-index="0"] .entry-side--left .timeline-card {
  margin-top: 2rem;
}

/* ── NAME placeholder label ── */
.entry-label {
  font-family: 'Oswald', sans-serif;
  font-size: 1.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 4px;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* compensate the trailing letter-spacing gap so the name sits truly centered */
.entry-label > span {
  padding-left: 4px;
}

/* Repeat-champion stars — sit under the name, inherit the name's color */
.winner-stars {
  margin-top: 0.4rem;
  font-size: 1.7rem;
  line-height: 1;
  letter-spacing: 5px;
  padding-left: 5px;
  color: currentColor;
}

.timeline-card {
  text-align: center;
}

/* Animation state — generalized by side so it works for ANY number of entries
   (no per-index rules to maintain when months are added). Left-side items slide
   in from the left, right-side items from the right. */
.timeline-entry .entry-side--left .timeline-card,
.timeline-entry .entry-side--left .entry-label {
  opacity: 0;
  transform: translateX(-40px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.timeline-entry .entry-side--right .timeline-card,
.timeline-entry .entry-side--right .entry-label {
  opacity: 0;
  transform: translateX(40px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.timeline-entry--visible .entry-side--left .timeline-card,
.timeline-entry--visible .entry-side--left .entry-label,
.timeline-entry--visible .entry-side--right .timeline-card,
.timeline-entry--visible .entry-side--right .entry-label {
  opacity: 1;
  transform: translateX(0);
}

/* Stagger delays */
.timeline-entry--visible[data-index="0"] .entry-side--left .timeline-card,
.timeline-entry--visible[data-index="0"] .entry-side--right .entry-label {
  transition-delay: 0s;
}

.timeline-entry--visible[data-index="1"] .entry-side--left .entry-label,
.timeline-entry--visible[data-index="1"] .entry-side--right .timeline-card {
  transition-delay: 0.1s;
}

.timeline-entry--visible[data-index="2"] .entry-side--left .timeline-card,
.timeline-entry--visible[data-index="2"] .entry-side--right .entry-label {
  transition-delay: 0.2s;
}

.timeline-entry--visible[data-index="3"] .entry-side--left .entry-label,
.timeline-entry--visible[data-index="3"] .entry-side--right .timeline-card {
  transition-delay: 0.3s;
}

.timeline-entry--visible[data-index="4"] .entry-side--left .timeline-card,
.timeline-entry--visible[data-index="4"] .entry-side--right .entry-label {
  transition-delay: 0.4s;
}

.timeline-entry--visible[data-index="5"] .entry-side--left .entry-label,
.timeline-entry--visible[data-index="5"] .entry-side--right .timeline-card {
  transition-delay: 0.5s;
}

.timeline-entry--visible[data-index="6"] .entry-side--left .timeline-card,
.timeline-entry--visible[data-index="6"] .entry-side--right .entry-label {
  transition-delay: 0.6s;
}

.timeline-entry--visible[data-index="7"] .entry-side--left .entry-label,
.timeline-entry--visible[data-index="7"] .entry-side--right .timeline-card {
  transition-delay: 0.7s;
}

/* ── Mobile: keep centered line with alternating layout ── */
@media (max-width: 560px) {
  .jam-page {
    overflow-x: hidden;
  }

  .champion-section-inner {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .champion-line-dots {
    left: 1.5rem;
    right: 1.5rem;
  }

  .champion-bottom-lines {
    left: 1.5rem;
    right: 1.5rem;
  }

  .jam-container {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
    box-sizing: border-box;
  }

  .timeline {
    gap: 40px;
    padding: 20px 0;
    width: 100%;
    box-sizing: border-box;
  }

  .timeline-line {
    left: 50%;
    transform: translateX(-50%);
  }

  .timeline-entry {
    align-items: center;
  }

  .entry-side--left {
    padding-right: 1.5rem;
  }

  .entry-side--right {
    padding-left: 1.5rem;
  }

  .timeline-dot {
    width: 14px;
    height: 14px;
  }

  .img-box {
    width: 120px;
    height: 220px;
  }

  .timeline-name {
    font-size: 0.85rem;
    letter-spacing: 1px;
  }

  .entry-label {
    font-size: 0.8rem;
    letter-spacing: 1px;
    white-space: nowrap;
  }
}
</style>
